class QuantityBlocks extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.quantity-blocks__input');
    this.blocks = this.querySelectorAll('.quantity-blocks__block');
    this.changeEvent = new Event('change', { bubbles: true });
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    // Set initial active state
    const initialValue = parseInt(this.input.value) || 1;
    this.setActiveBlock(initialValue);

    // Add click handlers to blocks
    this.blocks.forEach((block) => {
      block.addEventListener('click', (e) => {
        e.preventDefault();
        const quantity = parseInt(block.dataset.quantity);
        this.selectQuantity(quantity);
      });
    });

    // Listen for external quantity updates
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.handleExternalUpdate.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  selectQuantity(quantity) {
    const min = parseInt(this.input.dataset.min) || 1;
    const max = this.input.dataset.max ? parseInt(this.input.dataset.max) : null;

    // Validate quantity
    if (quantity < min) {
      quantity = min;
    }
    if (max && quantity > max) {
      quantity = max;
    }

    // Update input value
    this.input.value = quantity;
    this.input.setAttribute('value', quantity);
    this.setActiveBlock(quantity);
    
    // Also update any other quantity inputs in the form to ensure consistency
    const formId = this.input.getAttribute('form');
    if (formId) {
      const form = document.getElementById(formId);
      if (form) {
        // Update all quantity inputs in the form
        const allQuantityInputs = form.querySelectorAll('input[name="quantity"]');
        allQuantityInputs.forEach(input => {
          if (input !== this.input) {
            input.value = quantity;
            input.setAttribute('value', quantity);
            // Dispatch change event on other inputs too
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    }
    
    // Also update quantity inputs outside the form that might be connected via form attribute
    const allFormQuantityInputs = document.querySelectorAll(`input[name="quantity"][form="${formId}"]`);
    allFormQuantityInputs.forEach(input => {
      if (input !== this.input) {
        input.value = quantity;
        input.setAttribute('value', quantity);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    // Dispatch change event
    this.input.dispatchEvent(this.changeEvent);
    
    // Also trigger input event for better compatibility
    const inputEvent = new Event('input', { bubbles: true });
    this.input.dispatchEvent(inputEvent);
  }

  setActiveBlock(quantity) {
    this.blocks.forEach((block) => {
      const blockQuantity = parseInt(block.dataset.quantity);
      if (blockQuantity === quantity) {
        block.classList.add('active');
      } else {
        block.classList.remove('active');
      }
    });
  }

  handleExternalUpdate() {
    // Handle external quantity updates (e.g., from variant changes)
    const currentValue = parseInt(this.input.value) || 1;
    this.setActiveBlock(currentValue);
  }
}

if (!customElements.get('quantity-blocks')) {
  customElements.define('quantity-blocks', QuantityBlocks);
}

